/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Sending_ErrorInputs */

const ja_contact_sending_error = /** @type {(inputs: Contact_Sending_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー`)
};

const en_contact_sending_error = /** @type {(inputs: Contact_Sending_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorry, the mail cannot be sent`)
};

/**
* | output |
* | --- |
* | "Sorry, the mail cannot be sent" |
*
* @param {Contact_Sending_ErrorInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_sending_error = /** @type {((inputs?: Contact_Sending_ErrorInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Sending_ErrorInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_sending_error(inputs)
	return en_contact_sending_error(inputs)
});